import { createViewColor } from './create'

export const viewColors = {
  create: createViewColor,
}
